import 'css-chunksrc/feature/check-split/CheckPageSplit.module.scss';export default {
  "root": "CheckPageSplit_root",
  "card": "CheckPageSplit_card",
  "card-selected": "CheckPageSplit_card-selected",
  "items": "CheckPageSplit_items",
  "placeholder-chk": "CheckPageSplit_placeholder-chk",
  "card-title": "CheckPageSplit_card-title",
  "card-footer": "CheckPageSplit_card-footer",
  "check_label": "CheckPageSplit_check_label",
  "has-add-btn": "CheckPageSplit_has-add-btn",
  "resetBtn": "CheckPageSplit_resetBtn",
  "page-main": "CheckPageSplit_page-main"
};